import { useQuery } from '@tanstack/react-query';
import { CompanyService } from '../services/company.service';

export function useCompanyUsage(companyId: string) {
  const query = useQuery({
    queryKey: ['company-usage', companyId],
    queryFn: () => CompanyService.getUsageStats(companyId),
    enabled: !!companyId,
    refetchInterval: 1000 * 60 * 5, // Refetch every 5 minutes
  });

  return {
    usage: query.data,
    isLoading: query.isLoading,
  };
}
